<template>
  <div id="login" class="d-flex">
    <div class="col-gauche">
      <div class="page-content">
        <div class="page-single-content">
          <!-- <img src="../img/sud-thd-logo-blanc.png" class="logo-sud-thd" /> -->
          <div class="img-login">
            <img
              src="../img/macs-big-transparent.png"
              alt="img"
              style="max-width:512px !important;"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-droite">
      <div class="page-single-content">
        <div class="content-login">
          <div class="row" v-if="userConnected.id != null">
            <div class="col-md-8 content-form-login">
              <div>
                <h1>Nouveau mot de passe</h1>
                <p class="text-muted">Saisissez votre nouveau mot de passe</p>
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon icon="lock"></font-awesome-icon>
                </span>
                <b-form-input
                  v-model="password"
                  type="password"
                  placeholder="Mot de passe"
                ></b-form-input>
              </div>
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon icon="lock"></font-awesome-icon>
                </span>
                <b-form-input
                  v-model="passwordConfirm"
                  type="password"
                  placeholder="Confirmation du mot de passe"
                ></b-form-input>
              </div>
              <div class="col-xs-12 no-padding marginTop">
                <b-button
                  type="button"
                  class="btn-block"
                  variant="warning"
                  @click="doUpdatePassword()"
                >
                  <font-awesome-icon icon="arrow-right"></font-awesome-icon>
                  Envoyer
                </b-button>
              </div>
              <div class="col-xs-12 no-padding marginTop">
                Retourner à l'<router-link to="/login"
                  >identification</router-link
                >
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-md-8 content-form-login">
              <div>
                <h1>
                  Votre lien n'est plus valide, veuillez relancer une demande de
                  récupération de mot de passe
                </h1>
              </div>
              <div class="col-xs-12 no-padding marginTop">
                Retourner à l'<router-link to="/login"
                  >identification</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index.js";
export default {
  name: "Password",
  methods: {
    ...Vuex.mapActions("Authentification", ["getUserConnected"]),
    ...Vuex.mapActions("User", ["updatePassword"]),
    doUpdatePassword() {
      let user = this.userConnected;
      user.password = this.password;
      user.passwordConfirm = this.passwordConfirm;
      this.updatePassword(user);
    },
  },
  computed: {
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
  mounted() {
    this.token = this.$route.params.token;
    Vue.axios.defaults.headers.common["Authorization"] = "Bearer " + this.token;
    this.getUserConnected();
  },
  data: () => ({
    token: "",
    password: "",
    passwordConfirm: "",
  }),
};
</script>

<style></style>
